import { useTranslation } from 'react-i18next'

import { useAppSettings } from '@/stores/useAppSettings'

interface SEOProps {
  title?: string
  description?: string
  image?: string
  url?: string
  type?: 'website' | 'article'
  siteName?: string
  children?: React.ReactNode
}

export function SEO({ title, description, image, url, type = 'website', siteName, children }: SEOProps) {
  const { t, i18n } = useTranslation(['common'])
  const { getSetting } = useAppSettings()

  const appName = getSetting('general.app_name', t('common:app.name', 'BarBella Gym'))
  const appDescription = getSetting('general.app_description', t('common:app.description', 'Gym management app'))

  const defaultSiteName = siteName || appName
  const defaultDescription = description || appDescription
  const fullTitle = title ? `${title} | ${defaultSiteName}` : defaultSiteName
  const locale = i18n.language === 'ar' ? 'ar_AR' : 'en_US'

  return (
    <>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name='description' content={defaultDescription} />

      {/* Open Graph / Facebook */}
      <meta property='og:title' content={fullTitle} />
      <meta property='og:description' content={defaultDescription} />
      {type && <meta property='og:type' content={type} />}
      {url && <meta property='og:url' content={url} />}
      {image && <meta property='og:image' content={image} />}
      <meta property='og:site_name' content={defaultSiteName} />
      <meta property='og:locale' content={locale} />

      {/* Twitter */}
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={fullTitle} />
      <meta name='twitter:description' content={defaultDescription} />
      {image && <meta name='twitter:image' content={image} />}

      {/* Additional custom meta tags */}
      {children}
    </>
  )
}
